import DefaultMetrixService from '@/modules/Metrix/DefaultMetrixService';
import { VueConstructor } from 'vue/types/vue';
import { LazyMetrixInstaller } from '@/modules/Metrix/LazyMetrixInstaller';

const METRIKA_CONFIG = {
    id: 39773665,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    trackHash: true,
};

export const MetrixPlugin = {
    async install(Vue: VueConstructor) {
        const authMetrixService = new DefaultMetrixService();
        const metricsInstaller = new LazyMetrixInstaller(METRIKA_CONFIG);

        // Устанавливаем в прототип сразу, чтобы обработчики стали доступны
        // HACK: делаем как readonly и скрываем от парсера IDE, тк у нас есть vue.d.ts для этого дела
        [
            ['$relay', authMetrixService],
            ['$metrics', metricsInstaller],
        ].forEach(([key, handler]) => {
            Object.defineProperty(Vue.prototype, key as string, {
                value: handler,
            });
        });
    },
};
